import React, { useMemo } from 'react';
import { Alert, Table, TableBody, TableCell, TableHead, TableRow, Typography, Box } from '@mui/material';

export const computeSpeciesDistribution = (samples = []) => {
  const result = {};

  {
    console.log('computeSpeciesDistribution ==', samples);
  }

  samples
    .filter(s => s.takeOut === 'Yes')
    .forEach(s => {
      const { sampleName, species, dbh } = s;
      if (!sampleName || !species || !dbh) return;

      if (!result[sampleName]) result[sampleName] = {};
      if (!result[sampleName][species]) result[sampleName][species] = 0;

      result[sampleName][species] += Number(dbh);
    });

  {
    console.log('result ==', result);
  }
  const final = [];

  Object.entries(result).forEach(([sampleName, speciesObj]) => {
    const totalDBH = Object.values(speciesObj).reduce((a, b) => a + b, 0);

    Object.entries(speciesObj).forEach(([species, value]) => {
      final.push({
        sampleName,
        species,
        totalDBH: value,
        percentage: Number(((value / totalDBH) * 100).toFixed(2)),
      });
    });
  });

  return final;
};

const SpeciesTable = ({ samples = [], areaInHa }) => {
  const data = useMemo(() => computeSpeciesDistribution(samples), [samples]);

  if (!data.length) {
    return <Alert severity="info">Species will be auto-captured from the samples.</Alert>;
  }

  const totalPercentage = data.reduce((sum, r) => sum + r.percentage, 0).toFixed(1);

  return (
    <>
      <Alert severity="info" sx={{ mb: 2 }}>
        Species distribution calculated from DBH of takeout samples
      </Alert>

      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Species</TableCell>
            <TableCell>Sample</TableCell>
            <TableCell align="right">Area (Ha)</TableCell>
            <TableCell align="right">% of Site</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((row, idx) => (
            <TableRow key={`${row.sampleName}_${row.species}_${idx}`}>
              <TableCell>{row.species}</TableCell>
              <TableCell>{row.sampleName}</TableCell>
              <TableCell align="right">{areaInHa ?? '-'}</TableCell>
              <TableCell align="right">{row.percentage.toFixed(2)}%</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Box sx={{ mt: 2, textAlign: 'right' }}>
        <Typography variant="body2" fontWeight={600}>
          Total: {totalPercentage}%
        </Typography>
      </Box>
    </>
  );
};

export default SpeciesTable;
